<template>
  <v-card class="mx-auto mt-n3">
    <v-img :src="`${url}${data.banners[0].web}`" class="my-3" contain />
    <v-card-title
      class="justify-center text-uppercase page-title"
      :class="{ 'page-titleSm': $vuetify.breakpoint.smAndDown }"
    >
      {{ data.parent.title }}
    </v-card-title>

    <v-card-subtitle
      class="text-center page-sub-title"
      :class="{ 'page-subtitleSm': $vuetify.breakpoint.smAndDown }"
    >
      <h1 :class="$vuetify.breakpoint.smAndDown ? 'mt-5' : 'mt-0'">
        {{ data.title }}
      </h1>
    </v-card-subtitle>

    <v-container>
      <v-row
        v-scrollanimation
        align="center"
        justify="center"
        :class="{ charmSmall: $vuetify.breakpoint.smAndDown }"
        class="mb-5"
      >
        <v-col
          cols="12"
          sm="6"
          md="6"
          :class="[$vuetify.breakpoint.smAndDown ? 'order-2' : 'order-1']"
        >
          <v-card
            class="mx-auto"
            flat
            :class="$vuetify.breakpoint.smAndDown ? 'pl-3' : ' pl-0'"
            v-for="(content, i) in data.contents"
            :key="i"
          >
            <v-card-title
              class="text-h5 font-weight-bold"
              :class="{ mlcptext: $vuetify.breakpoint.smAndUp }"
            >
              {{ content.title }}
            </v-card-title>
            <v-card-text>
              <div class="text--primary">
                {{ content.description }}
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="6"
          :class="[$vuetify.breakpoint.smAndDown ? 'order-1' : 'order-2']"
        >
          <v-hover>
            <div
              slot-scope="{ hover }"
              :class="`${hover ? 'imgover' : 'imgleave'}`"
            >
              <v-img
                class="rounded-xl"
                :src="`${url}${data.images[0].web.url}`"
                :width="$vuetify.breakpoint.smAndDown ? '100%' : '80%'"
                :class="$vuetify.breakpoint.smAndDown ? 'ml-0' : 'ml-10'"
              ></v-img>
            </div>
          </v-hover>
        </v-col>
      </v-row>

      <v-row
        v-scrollanimation
        align="center"
        justify="center"
        :class="{ charmSmall: $vuetify.breakpoint.smAndDown }"
      >
        <v-col cols="12" sm="6" md="6">
          <div class="tableHead">
            <p>Multi Level Car Parking West</p>
            <!-- <span>MLCP is 1km away from the main enterance</span> -->
          </div>
          <v-data-table
            :headers="parking.headers"
            :items="parking.data.west"
            hide-default-footer
            class="elevation-1 mb-5 ml-1 mr-1 custom-table"
          ></v-data-table>
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <div class="tableHead">
            <p>Multi Level Car Parking East</p>
            <!-- <span>MLCP is 1km away from the main enterance</span> -->
          </div>
          <v-data-table
            :headers="parking.headers"
            :items="parking.data.east"
            hide-default-footer
            class="elevation-1 mb-5 ml-1 mr-1 custom-table"
          ></v-data-table>
        </v-col>
      </v-row>

      <v-row v-scrollanimation align="center" justify="center" class="mb-5">
        <v-col cols="12" sm="12" md="12">
          <p :class="$vuetify.breakpoint.smAndDown ? 'ml-0, mt-3' : 'ml-2'">
            {{ current.fullDate }},
            <a @click="onLoadParking" :disabled="isRefreshing" >
              <span style="color: black">Click here to </span><span :style="{ color: isRefreshing ? 'gray' : '' }">Refresh</span>
              <v-icon :color="isRefreshing ? 'gray' : 'primary'" size="20"> mdi-refresh </v-icon></a
            >
          </p>
        </v-col>
      </v-row>

      <v-row
        class="mb-15"
        v-scrollanimation
        align="center"
        justify="center"
        :class="{ charmSmall: $vuetify.breakpoint.smAndDown }"
      >
        <v-col
          cols="12"
          sm="6"
          md="6"
          :class="[$vuetify.breakpoint.smAndDown ? 'order-2' : 'order-1']"
        >
          <v-card class="mx-auto ultimateChoice" flat>
            <v-card-title
              class="text-uppercase page-title ml-5"
              :class="{ 'page-titleSm': $vuetify.breakpoint.smAndDown }"
            >
              {{ data.parent.title }}
            </v-card-title>
            <v-card-text>
              <h2 class="pr-2">MLCP Parking Charges</h2>

              <p class="mt-5">
                Discover Convenient Parking rates for every vehicle: car,
                Motorcycles & more.
              </p>
            </v-card-text>
          </v-card>
          <v-card-actions>
            <v-btn
              to="/mlcp"
              rounded
              dark
              class="gradient-button text-capitalize"
              style="padding: 10px 20px !important"
            >
              Show Rates
            </v-btn>
          </v-card-actions>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="6"
          :class="[$vuetify.breakpoint.smAndDown ? 'order-1' : 'order-2']"
        >
          <v-sheet class="pa-2">
            <v-hover>
              <div
                slot-scope="{ hover }"
                :class="`${hover ? 'imgover' : 'imgleave'}`"
              >
                <v-img
                  class="rounded-xl"
                  src="../../assets/images/mlcp-charges.jpg"
                ></v-img>
              </div>
            </v-hover>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import config from "../../config";
import api from "../../api";
export default {
  name: "Template-4",
  props: ["data"],
  data() {
    return {
      url: config.airport.url,
      isRefreshing:false,
      parking: {
        headers: [
          {
            text: "Levels",
            align: "center",
            sortable: false,
            value: "Countername",
          },

          {
            text: "Space Availability",
            align: "center",
            value: "EmptyCar",
          },
        ],
        data: {
          east: [],
          west: [],
        },
      },
    };
  },
  computed: {
    current: {
      get() {
        return this.$store.getters.current;
      },
    },
  },
  methods: {
    async onLoadParking() {
      if (this.isRefreshing) return; 
      try {
        this.isRefreshing = true;
        this.$store.dispatch("onSetCurrentDate");
        const east_api = await api.parking.get("1");
        const west_api = await api.parking.get("2");

        const [east, west] = await Promise.all([east_api, west_api]);
        this.parking.data.east = east.data;
        this.parking.data.west = west.data;
        this.isRefreshing = false;
       
      } catch (error) {
        this.isRefreshing = false;
      }
    },
  },
  async mounted() {
    await this.onLoadParking();
  },
};
</script>
<style scoped>
.mlcptext {
  width: 90%;
}

.tableHead {
  text-align: center;
  background: #f9fafb;
  border-radius: 35px 35px 0 0;
  padding: 15px 0;
  width: 99%;
  margin: 0 auto;
  border: thin solid rgba(0, 0, 0, 0.12);
}

.tableHead p {
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #374151;
}

.tableHead span {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #6b7280;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > thead
  > tr:last-child
  > th {
  border-bottom: none;
}

.v-card__actions {
  padding: 8px;
}
</style>
